import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import VideoSection from './components/VideoSection';
import EventsSection from './components/EventsSection';
import GallerySection from './components/GallerySection';
import NewsSection from './components/NewsSection';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Apply dark mode class to document
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
      <Header isScrolled={isScrolled} isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <Hero />
      <div className={isDarkMode ? 'bg-gray-900' : 'bg-white'}>
        <VideoSection isDarkMode={isDarkMode} />
        <EventsSection isDarkMode={isDarkMode} />
        <GallerySection isDarkMode={isDarkMode} />
        <NewsSection isDarkMode={isDarkMode} />
      </div>
      <Footer isDarkMode={isDarkMode} />
    </div>
  );
}